function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { Overlay, WrapContent } from "./style";
import { ModalTitle } from "./ModalTitle";
import { ModalContent } from "./ModalContent";
import { ModalActions } from "./ModalActions";
import { constants } from "../../styles";
import Button from "../Button";

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal(props) {
    _classCallCheck(this, Modal);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      isOpen: false
    };

    _this.toggle = _this.toggle.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleConfirm = _this.handleConfirm.bind(_this);
    return _this;
  }

  Modal.prototype.getModalActions = function getModalActions() {
    var _props = this.props,
        confirmLabel = _props.confirmLabel,
        cancelLabel = _props.cancelLabel,
        disableActions = _props.disableActions,
        status = _props.status;


    return React.createElement(
      ModalActions,
      null,
      React.createElement(
        Button,
        { plain: true, onClick: this.handleClose, disabled: disableActions },
        cancelLabel
      ),
      confirmLabel && React.createElement(
        Button,
        {
          type: "button",
          color: status,
          onClick: this.handleConfirm,
          disabled: disableActions
        },
        confirmLabel
      )
    );
  };

  Modal.prototype.handleConfirm = function handleConfirm() {
    var confirmAction = this.props.confirmAction;

    confirmAction();
    this.toggle();
  };

  Modal.prototype.handleClose = function handleClose() {
    var closeAction = this.props.closeAction;

    closeAction();
    this.toggle();
  };

  Modal.prototype.toggle = function toggle() {
    this.setState(function (prevState) {
      return {
        isOpen: !prevState.isOpen
      };
    });
  };

  Modal.prototype.render = function render() {
    var _props2 = this.props,
        children = _props2.children,
        status = _props2.status,
        title = _props2.title,
        triggerComponent = _props2.triggerComponent,
        smallModal = _props2.smallModal;
    var isOpen = this.state.isOpen;


    return React.createElement(
      Fragment,
      null,
      triggerComponent({ onClick: this.toggle }),
      ReactDOM.createPortal(isOpen && React.createElement(
        Overlay,
        null,
        React.createElement(
          WrapContent,
          { smallModal: smallModal },
          title && React.createElement(
            ModalTitle,
            { status: status },
            title
          ),
          React.createElement(
            ModalContent,
            null,
            children
          ),
          this.getModalActions()
        )
      ), document.body)
    );
  };

  return Modal;
}(Component);

var _constants$colors = constants.colors,
    DEFAULT = _constants$colors.DEFAULT,
    PRIMARY = _constants$colors.PRIMARY,
    SECONDARY = _constants$colors.SECONDARY,
    SUCCESS = _constants$colors.SUCCESS,
    WARNING = _constants$colors.WARNING,
    DANGER = _constants$colors.DANGER;


Modal.propTypes = {
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  confirmAction: PropTypes.func,
  disableActions: PropTypes.bool,
  status: PropTypes.oneOf([DEFAULT, PRIMARY, SECONDARY, SUCCESS, WARNING, DANGER]),
  closeAction: PropTypes.func,
  title: PropTypes.string.isRequired,
  triggerComponent: PropTypes.func.isRequired,
  smallModal: PropTypes.bool,
  children: PropTypes.node.isRequired
};

Modal.defaultProps = {
  confirmLabel: null,
  cancelLabel: null,
  confirmAction: null,
  disableActions: false,
  status: PRIMARY,
  closeAction: null,
  smallModal: false
};

export default Modal;